<template>
  <div>
    <v-autocomplete
      return-object
      hide-details
      :label="label"
      :items="items"
      item-text="isim"
      v-model="Model"
    >
    </v-autocomplete>
  </div>
</template>

<script>
import tool from "../tools";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";

export default {
  props: [
    "value",
    "apiname",
    "getcode",
    "getkk",
    "label",
    "tip",
    "required",
    "rules",
  ],
  components: {
    arksnackbar,
  },
  computed: {
    Model: {
      get: function () {
        if (
          this.value != undefined &&
          this.value != null &&
          this.value.Id != null
        ) {
          var r = {
            Id: this.value.Id,
            isim: this.value.isim + '1',
            kod: this.value.kod,
            tip: this.value.tip,
            YurtIci_YurtDisi: this.value.YurtIci_YurtDisi,
          };
          this.items = [r];
        }

        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },

  data() {
    return {
      deneme: null,
      loading: false,
      items: [],
      search: null,
      status: tool.NewSatatus(),
      ayrac: "  -  ",
    };
  },

  watch: {
    getcode: function (val) {
if (val.kod != undefined) {
        this.querySelections(this.getkk, val.kod);
      } else {
        this.querySelections(this.getkk, val);
      }
    },
    getkk: function (val) {
      if (this.getcode != undefined && this.getcode != null) {
        this.querySelections(val, this.getcode.kod);
      } else {
        this.querySelections(val, this.getcode);
      }
    },
  },
  mounted() {
    if (this.getcode != undefined && this.getcode != null) {
      this.querySelections(this.getkk, this.getcode.kod);
    } else {
      this.querySelections(this.getkk, this.getcode);
    }
  },
  methods: {
    querySelections(vt, kk) {
      var prm = {
        VizeTip: vt,
        KonsoloslukKodu: kk,
      };

      setTimeout(() => {
        this.Ara(prm);
      }, 400);
    },

    IsimAra(v) {
      return (
        v.isim.replace(this.ayrac, "-") +
        this.ayrac +
        v.kod.replace(this.ayrac, "-")
      );
    },

    Ara(prm) {
      this.status.loading = true;
      this.items = [];
      tool.http_post(this, "VizeCesidiList", prm).then(
        (response) => {
          this.items = response.body.data;
          this.items.forEach((item, index)=>{
	item.isim=this.$t(item.isim)
})
        },
        (response) => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
  },
};
</script>